import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["button", "buttonProps", "cardLabel", "cardLabelProps", "children", "classes", "icon", "onButtonClick", "mobileText", "onClose", "title", "text", "textProps", "titleProps"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { CloseSmallLinear } from "../icons";
import { ButtonBase } from "../internal/ButtonBase";
import { TextBase } from "../internal/TextBase";
import Button from '../Button';
import { CardLabel } from '../CardLabel';
import Title from '../Title';
import styles from './Banner.css';
var cx = classNames.bind(styles);
var Banner = /*#__PURE__*/forwardRef(function Banner(_ref, ref) {
  var button = _ref.button,
      buttonProps = _ref.buttonProps,
      cardLabel = _ref.cardLabel,
      cardLabelProps = _ref.cardLabelProps,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      icon = _ref.icon,
      onButtonClick = _ref.onButtonClick,
      mobileText = _ref.mobileText,
      onClose = _ref.onClose,
      title = _ref.title,
      text = _ref.text,
      textProps = _ref.textProps,
      titleProps = _ref.titleProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref,
    className: cx('root', classes.root)
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('inner', classes.inner)
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: cx('icon', 'mobile', classes.icon)
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('title', 'desktop', classes.title)
  }, /*#__PURE__*/React.createElement(Title, _extends({
    as: "span",
    level: 3
  }, titleProps), title)), /*#__PURE__*/React.createElement("div", {
    className: cx('title', 'mobile', classes.title)
  }, /*#__PURE__*/React.createElement(Title, _extends({
    as: "span",
    color: "R600",
    level: 5
  }, titleProps), title))), /*#__PURE__*/React.createElement("div", {
    className: cx('description', classes.description)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('text', 'desktop', classes.text)
  }, /*#__PURE__*/React.createElement(TextBase, _extends({
    size: "l"
  }, textProps), text)), /*#__PURE__*/React.createElement("div", {
    className: cx('text', 'mobile', classes.text)
  }, /*#__PURE__*/React.createElement(TextBase, textProps, mobileText)), button && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('button', 'desktop', classes.button)
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: onButtonClick,
    size: "large",
    theme: "white"
  }, buttonProps), button)), /*#__PURE__*/React.createElement("div", {
    className: cx('button', 'mobile', classes.button)
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: onButtonClick,
    size: "small",
    theme: "secondary"
  }, buttonProps), button)))), children)), onClose && /*#__PURE__*/React.createElement(ButtonBase, {
    className: cx('close'),
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseSmallLinear, null)), cardLabel && /*#__PURE__*/React.createElement("div", {
    className: cx('card_label', classes.cardLabel)
  }, /*#__PURE__*/React.createElement(CardLabel, _extends({
    position: "topLeft"
  }, cardLabelProps), cardLabel)));
});
export default Banner;